import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { toDollar } from "../../../utils/dataConverter";

export default function FormLayoutBalanceDue({
  children,
  className = "",
  finalBalance,
  isRefund = false,
}: any) {
  const notRequired = Math.abs(finalBalance) <= import.meta.env.VITE_APP_SAAS_CUSTOMER_PAYMENT_THRESHOLD;
  return (
    <Grid container className={`form-container form-static ${className}`}>
      <Box component="p" m={0} className='subtitle'>
        Review Balance
      </Box>
      <Box component="h1" m={0} className='title'>
        {notRequired ? 'No Balance Due / No Refund Owed' : (isRefund ? 'Refund Owed': 'Balance Due')}
      </Box>
      {!notRequired && <Box component="h2" m={0} className='description'>
        You have a balance due of{" "}
        <span className='amount'>{toDollar(finalBalance)}.</span>
      </Box>}
      {children}
    </Grid>
  );
}
